import { StaticInterface } from '../../../helpers/static-interface';
import Lottie from 'lottie-web';
import { illustration } from './illustration';

export interface ITpxSuperheroUtils {
  loadLottie(parentEl: HTMLElement, json: Object): void;
}

export interface IStaticSuperheroUtils {
  new(...args: any[]): ITpxSuperheroUtils;
  init(): void;
}

/**
 * Superhero utilities
 * @class
 */
export default class TpxSuperheroUtils
  implements StaticInterface<IStaticSuperheroUtils, typeof TpxSuperheroUtils> {
  constructor(element: HTMLElement) {
    this.loadLottie(element, illustration);
  }

  /**
   * Load lottie animations
   */
  loadLottie(parentEl: HTMLElement, json: Object): void {
    const container = parentEl.querySelector(
      '[data-component="superhero__illustration"]'
    );

    if (container !== null) {
      //load the animation and autoplay it if user has not set prefers reduced motion on their device
      const prefersReducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
      Lottie.loadAnimation({
        animationData: json,
        container,
        renderer: 'svg',
        loop: true,
        autoplay: !prefersReducedMotion,
      });
    }
  }

  /**
   * Create new instances of TpxSuperhero for each element with attribute data-component="superhero"
   */
  static init(scope?: HTMLElement) {
    [
      ...(scope || document).querySelectorAll('[data-component="superhero"]'),
    ].forEach((hero) => {
      new TpxSuperheroUtils(hero as HTMLElement);
    });
  }
}
